'use client';

import { useAuth } from '@/contexts/AuthContext';
import { NextIntlClientProvider } from 'next-intl';
import { useEffect, useState } from 'react';

export default function TranslationProvider({ children }: { children: React.ReactNode }) {
  const { userLang } = useAuth();
  const [messages, setMessages] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const mod = await import(`public/idioma/${userLang}.json`);
        setMessages(mod.default);
      } catch (e) {
        console.error(`No translations found for locale: ${userLang}`);
        const fallback = await import('public/idioma/es-ES.json');
        setMessages(fallback.default);
      }
    };

    loadMessages();
  }, [userLang]);

  if (!messages) return null; 
  return (
    <NextIntlClientProvider locale={userLang || 'es-ES'} messages={messages}>
      {children}
    </NextIntlClientProvider>
  );
}
